import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeftIcon } from '@heroicons/react/24/solid';

const TermsAndConditions: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-4xl mx-auto px-4 py-8">
        <div className="bg-white rounded-lg shadow-md overflow-hidden">
          <div className="flex items-center p-6 border-b border-gray-200 bg-navy-blue text-white">
            <button
              type="button"
              onClick={() => navigate(-1)}
              className="mr-4 text-blue-500 hover:text-gray-200"
            >
              <ArrowLeftIcon className="h-5 w-5" />
            </button>
            <h1 className="text-xl font-semibold">Terms and Conditions</h1>
          </div>
          
          <div className="p-6">
            <div className="prose max-w-none">
              <h2 className="text-2xl font-bold text-navy-blue mb-6">Terms of Use</h2>
              
              <div className="mb-8">
                <h3 className="text-xl font-semibold text-sky-blue mb-3">Introduction</h3>
                <p className="text-gray-700 mb-4 leading-relaxed">
                  These terms and conditions (together with the documents referred to herein) tells you the terms of 
                  use on which you may make use of our website (www.catchoftheday.io) and the mobile application 
                  known as "Catch of the Day" (hereinafter the "site"). Use of our site includes accessing, browsing, 
                  or registering to use our site.
                </p>
                <p className="text-gray-700 mb-4 leading-relaxed font-bold">
                  PLEASE READ THESE TERMS AND CONDITIONS CAREFULLY BEFORE USING THIS SITE. BY 
                  ACCESSING AND USING THIS SITE, YOU CONFIRM THAT YOU ACCEPT THESE TERMS AND CONDITIONS AND THAT YOU AGREE TO COMPLY WITH THEM. IF YOU DO NOT ACCEPT THESE TERMS 
                  AND CONDITIONS, THEN DO NOT USE THIS SITE OR ANY PART THEREOF.
                </p>
                <p className="text-gray-700 mb-4 leading-relaxed">
                  Users may be granted access to the public areas of this site and to the secure private areas.
                </p>
                <p className="text-gray-700 mb-4 leading-relaxed">
                  References to the 'site' in these terms and conditions relate to both the public and private secure areas.
                </p>
              </div>
              
              <div className="mb-8">
                <h3 className="text-xl font-semibold text-sky-blue mb-3">Other Applicable Terms</h3>
                <p className="text-gray-700 mb-4 leading-relaxed">
                  Our Privacy Policy sets out the terms on which we process any personal data we collect from you, 
                  or that you provide to us. By using our site, you consent to such processing and you warrant that 
                  all data provided by you is accurate.
                </p>
              </div>
              
              <div className="mb-8">
                <h3 className="text-xl font-semibold text-sky-blue mb-3">Information About Us</h3>
                <p className="text-gray-700 mb-4 leading-relaxed">
                  The site is controlled and operated by Catch of the Day LLC, a Bermuda local limited liability company, 
                  (hereinafter "CotD", "we", or "us").
                </p>
              </div>
              
              <div className="mb-8">
                <h3 className="text-xl font-semibold text-sky-blue mb-3">Changes to these terms</h3>
                <p className="text-gray-700 mb-4 leading-relaxed">
                  We may revise these terms of use at any time without notice by amending this page. 
                  Please check this page from time to time to take notice of any changes we made, as they are binding on you.
                </p>
              </div>
              
              <div className="mb-8">
                <h3 className="text-xl font-semibold text-sky-blue mb-3">Changes to our site</h3>
                <p className="text-gray-700 mb-4 leading-relaxed">
                  We may update our site from time to time, and may change the content at any time. However, please 
                  note that any of the content on our site may be out of date at any given time, and we are under no 
                  obligation to update it.
                </p>
              </div>
              
              <div className="mb-8">
                <h3 className="text-xl font-semibold text-sky-blue mb-3">Accessing our site</h3>
                <p className="text-gray-700 mb-4 leading-relaxed">
                  Subject to certain services which are only available via subscription, our site is made available free of charge. 
                  We do not guarantee that our site, or any content on it, will always be available or be uninterrupted.
                </p>
                <p className="text-gray-700 mb-4 leading-relaxed">
                  Access to our site is permitted on a temporary basis. We may suspend, withdraw, discontinue or change all 
                  or any part of our site without notice. We will not be liable to you if for any reason our site 
                  is unavailable at any time or any period.
                </p>
              </div>
              
              <div className="mb-8">
                <h3 className="text-xl font-semibold text-sky-blue mb-3">Your Account and Password</h3>
                <p className="text-gray-700 mb-4 leading-relaxed">
                  If you choose, or you are provided with, a user identification code, password or any other piece of 
                  information as part of our security procedures, you must treat such information as confidential. You 
                  must not disclose it to any third party.
                </p>
                <p className="text-gray-700 mb-4 leading-relaxed">
                  We have the right to disable any user identification code or password, whether chosen by you or allocated by us, 
                  at any time, if in our reasonable opinion you have failed to comply with any of the provisions of these terms of use.
                </p>
              </div>
              
              <div className="mb-8">
                <h3 className="text-xl font-semibold text-sky-blue mb-3">Intellectual Property</h3>
                <p className="text-gray-700 mb-4 leading-relaxed">
                  The content of this site including all images, text, programmes, and other materials, etc. is protected 
                  by law, including copyright law, trademark law and any other intellectual property rights relating to the 
                  content belonging to CotD or its licensors. CotD and/or its licensors are the owners of the data, design, 
                  graphics, text, images, software and underlying codes for use on this site.
                </p>
              </div>
              
              <div className="mb-8">
                <h3 className="text-xl font-semibold text-sky-blue mb-3">Responsibility of Donors</h3>
                <p className="text-gray-700 mb-4 leading-relaxed">
                  Where the site is used to facilitate the sale of food or the donation of food to recipients in need, such 
                  donor of food (the "Donor") shall:
                </p>
                <ul className="list-disc pl-6 space-y-2 text-gray-700">
                  <li className="leading-relaxed">
                    ensure that all donated food, including food past its sell-by date, is appropriately 
                    handled and stored prior to donation including in accordance with applicable law;
                  </li>
                  <li className="leading-relaxed">
                    ensure that donated food is assessed for safety and is safe for consumption at the time 
                    of donation; and
                  </li>
                  <li className="leading-relaxed">
                    provide appropriate instructions to the purchaser or recipient (the "Recipient") for safe 
                    handling of the donated food.
                  </li>
                </ul>
              </div>
              
              <div className="mb-8">
                <h3 className="text-xl font-semibold text-sky-blue mb-3">Limitation of Liability</h3>
                <p className="text-gray-700 mb-4 leading-relaxed">
                  Nothing in these terms of use excludes or limits our liability for death or personal injury arising from 
                  our negligence, or our fraud or fraudulent misrepresentation, or any other liability that cannot be 
                  excluded or limited by Bermuda law.
                </p>
                <p className="text-gray-700 mb-4 leading-relaxed">
                  To the extent permitted by law, we exclude all conditions, warranties, representations or other terms 
                  which may apply to our site or any content on it, whether express or implied.
                </p>
                <p className="text-gray-700 mb-4 leading-relaxed">
                  We will not be liable to any user for any loss or damage, whether in contract, tort (including negligence), 
                  breach of statutory duty, or otherwise, even if foreseeable, arising under or in connection with:
                </p>
                <ul className="list-disc pl-6 space-y-2 text-gray-700">
                  <li className="leading-relaxed">use of, or inability to use, our site; or</li>
                  <li className="leading-relaxed">use of or reliance on any content displayed on our site.</li>
                </ul>
              </div>
              
              <div className="mb-8">
                <h3 className="text-xl font-semibold text-sky-blue mb-3">Malware</h3>
                <p className="text-gray-700 mb-4 leading-relaxed">
                  We do not guarantee that our site will be secure from bugs, viruses or any form of malware. 
                  You are responsible for configuring your information technology, computer programs and platform 
                  in order to access our site. You should use your own endpoint protection software.
                </p>
                <p className="text-gray-700 mb-4 leading-relaxed">
                  You must not misuse our site by knowingly introducing viruses, trojans, worms, logic bombs or other 
                  material which is malicious or technologically harmful. You must not attempt to gain unauthorized 
                  access to our site, the server on which our site is stored or any server, computer or database 
                  connected to our site.
                </p>
              </div>
              
              <div className="mb-8">
                <h3 className="text-xl font-semibold text-sky-blue mb-3">General Provisions and Termination</h3>
                <p className="text-gray-700 mb-4 leading-relaxed">
                  If any provision of these terms is deemed void, unlawful or otherwise unenforceable for any reason, 
                  that provision shall be severed from these terms and the remaining provisions of these terms shall 
                  remain in force.
                </p>
                <p className="text-gray-700 mb-4 leading-relaxed">
                  You agree that we may, at our sole discretion, permanently or temporarily suspend or terminate your 
                  access to all or parts of the site with or without notice and for any reason, including, without 
                  limitation, breach of these terms.
                </p>
                <p className="text-gray-700 mb-4 leading-relaxed">
                  Your use of this site and any dispute arising out of such use is subject to the laws of Bermuda. 
                  Any such dispute is subject to the exclusive jurisdiction of the Bermuda courts.
                </p>
              </div>
              
              <div className="text-center text-gray-500 text-sm mt-12">
                Last updated: {new Date().toISOString().split('T')[0]}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
